import { ButtonLink } from 'components/ButtonLink';
import { useTranslation } from 'react-i18next';
import { routes } from 'router/routes';

export type Props = {
  className?: string;
};

export const OpenSupportCaseButton = ({ className }: Props) => {
  const { t } = useTranslation();

  return (
    <ButtonLink to={routes.openSupportCase} variant="secondary" size="md" className={className}>
      {t('helpCard.openSupportCase')}
    </ButtonLink>
  );
};
